// extracted by mini-css-extract-plugin
export default {"form":"profile-form_form__84EEM","buttonsContainer":"profile-form_buttonsContainer__f9qa5"};